(function (angular, app) {
   "use strict";

   angular.module(app.modules.view.name)
      .controller(app.modules.view.routes.intro.controller, IntroController);
      
   IntroController.$inject = [];
   
   function IntroController() {}
}(angular, app));
